import { render, staticRenderFns } from "./AssignToSalesRepresentative.vue?vue&type=template&id=64545b96"
import script from "./AssignToSalesRepresentative.vue?vue&type=script&lang=js"
export * from "./AssignToSalesRepresentative.vue?vue&type=script&lang=js"
import style0 from "./AssignToSalesRepresentative.vue?vue&type=style&index=0&id=64545b96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports